import React, {Component} from 'react';
import classNames from "classnames";

import {ReactComponent as PhoneIcon} from "../../assets/img/phone-icon.svg";

import './index.scss';


const PhoneNumber = (props) => {

    const componentClass = classNames('phone-number', props.className);

    return (
      <a href="tel:+49592479830000" className={componentClass}>
        <div className="phone-number__value">+49 5924 798300 00</div>
        <PhoneIcon className="phone-number__icon"/>
      </a>
    );

};

export default PhoneNumber;
